import React from 'react'
import { Link } from 'react-static'

import shield from '../../images/icons/shield.png'
import lbp from '../../images/lbp-white.png'

export default class HomeAbout extends React.Component {
  state = { loadImages: false }

  componentDidMount() {
    if (this.props.loaderHidden) {
      this.loadImages()
    }
  }

  componentWillReceiveProps(next) {
    if (next.loaderHidden && !this.props.loaderHidden) {
      this.loadImages()
    }
  }

  loadImages = () => {
    this.setState({ loadImages: true })
  }

  render () {
    const { loadImages } = this.state
    return (
      <section className="home-about">

        <div className="home-about__block">
          <div className="home-about__block-inner">
            <h2>About Us</h2>
            <p>Makuch Roofing has been involved in the NZ building industry for over 25 years. As we are licensed building practitioners, you’re assured of the highest building standards.</p>
            <p>Makuch arrive equipped with a strong track record of quality, integrity, care and safety. We only use trusted materials which are backed by their own warantees. Our workmanship is guaranteed for a period of five years.</p>
            <div className="home-about__quality-icons">
              <div>
                <img src={loadImages ? shield : '' } alt="5 year guarantee" />
              </div>
              <div>
                <img src={loadImages ? lbp : ''} alt="5 year guarantee" />
              </div>
            </div>
          </div>
        </div>

        <div className="home-about__block">
          <div className="home-about__block-inner">
            <h2>How Can We Help?</h2>
            <p>We can provide you with a free, no obligation quote for new home roofing, roof replacement, guttering and gutter replacement.</p>
            <p>Are you re-roofing a house or have plans
              for a new commercial building? Whatever your
              roofing project we’d love to hear about it.</p>
            <Link to="/contact">
              <button className="default-button">REQUEST A QUOTE</button>
            </Link>
          </div>
        </div>

      </section>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/home-page/HomeAbout.js